import { loadableWithFallback } from '@vision/ui/utils';
import type { RadarChart1Props } from './RadarChart1';

export const RadarChart1 = loadableWithFallback<RadarChart1Props>(() => import('./RadarChart1'));
